<template>
<div class="shopGroup form dialog-form">
    <el-dialog title="商品分组" :visible.sync="dialogVisible" @close="cancel">
        <div class="filters">
            <div class="search">
                <el-input placeholder="输入分组名称" v-model="param.subject" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
            <div class="add"></div>
        </div>
        <el-table :data="tableData" style="width: 100%" @select="selected" ref="multipleTable" max-height="300">
            <el-table-column type="selection" width="30"></el-table-column>
            <el-table-column label="直播名称" min-width="200px">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img v-lazy="scope.row.logourl" alt="" v-if="scope.row.logourl">
                        <img :src="defaultCover" alt="" v-else>
                        <div class="imageText-summary">
                            <div>{{ scope.row.subject }}</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="开始时间" prop="begintime"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
    </span>
    </el-dialog>
</div>
</template>

<script>
import {getVliveList} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'shopGroup',
    data() {
        return {
            param: {
                ispublic: '',
                subject: ''
            },
            page: {
                page: 0,
                pageSize: 10,
                pageCount: 0
            },
            dialogVisible: false,
            tableData: [],
            selectedResult: {
                innerid: '',
                name: ''
            },
            flag: true,
            scrollTop: 0 // 上一次滚动距离
        }
    },
    mounted() {
    },
    methods: {
        handleQuery() {
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        selected(selection, row) {
            let flag = true
            this.selectedResult.forEach((obj1, index1) => {
                if (obj1.objectid === row.innerid) {
                    flag = false
                    delete this.selectedResult[index1]
                }
            })
            if (flag) {
                this.selectedResult.push({
                    objectid: row.innerid,
                    objectname: row.subject,
                    kmctype: 3,
                    viewcount: 0,
                    uprice: 0,
                    saleprice: 0,
                    furl: row.logourl,
                    desc: ''
                })
            }
            this.selectedResult = this.selectedResult.filter(obj => obj)
        },
        openDialog(selectedResult) {
            this.tableData = []
            this.selectedResult = $.extend(true, [], selectedResult)
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.name = ''
            this.page = {
                page: 0,
                pageSize: 6,
                pageCount: 0
            }
            this.dialogVisible = false
        },
        submit() {
            this.$emit('setVlive', this.selectedResult)
            this.cancel()
        },
        _getList() {
            this.page.page++
            this.setLoading(true)
            getVliveList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = this.tableData.concat(data.data.content)
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    if (this.selectedResult.length) {
                        this.tableData.forEach(obj1 => {
                            this.selectedResult.forEach(obj2 => {
                                if (obj1.innerid === obj2.objectid) {
                                    this.$nextTick(() => {
                                        this.$refs.multipleTable.toggleRowSelection(obj1)
                                    })
                                }
                            })
                        })
                    }
                    this.setLoading(false)
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-table__body-wrapper').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.page.page < _this.page.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getList()
                                }
                            }
                        })
                    })
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopGroup {
    .el-dialog .el-button{
        margin-bottom: 0;
        margin-left: 30px;
    }
    .el-date-editor .el-range-separator,.filters .el-input__icon{
        line-height: 26px;
    }
    .el-table th>.cell:nth-child(1)>label{
        display: none;
    }
    .filters{
        @include flexBox(flex-start);
        .search{
            .el-input{
                width: 240px !important;
            }
        }
    }
    .imageText{
        @include flexBox(flex-start);
        img{
            min-width: 74px;
            max-width: 74px;
            height: 42px;
            margin-right: 10px;
        }
    }
}
</style>
